export const mockAppUpdate = {
  id: 'v1.4.0',
  version: '1.4.0',
  title: 'updateFeature.title',
  description: 'updateFeature.description',
  releaseDate: new Date('2026-03-01'),
  features: [
    {
      id: 'feature-1',
      title: 'updateFeature.features.generalSettings.title',
      description: 'updateFeature.features.generalSettings.description',
      icon: '⚙️',
      type: 'improvement' as const
    },
    {
      id: 'feature-2',
      title: 'updateFeature.features.smartAlerts.title',
      description: 'updateFeature.features.smartAlerts.description',
      icon: '🔔',
      type: 'new' as const
    },
    {
      id: 'feature-3',
      title: 'updateFeature.features.clientView.title',
      description: 'updateFeature.features.clientView.description',
      icon: '👁️',
      type: 'new' as const
    },
    {
      id: 'feature-4',
      title: 'updateFeature.features.companyBranding.title',
      description: 'updateFeature.features.companyBranding.description',
      icon: '🎨',
      type: 'improvement' as const
    },
    {
      id: 'feature-5',
      title: 'updateFeature.features.companyClients.title',
      description: 'updateFeature.features.companyClients.description',
      icon: '🏢',
      type: 'new' as const
    },
    {
      id: 'feature-6',
      title: 'updateFeature.features.detailView.title',
      description: 'updateFeature.features.detailView.description',
      icon: '✨',
      type: 'improvement' as const
    }
  ],
  priority: 'high' as const,
  showConfetti: true
}
